export const environment = {
  isProduction: true,
  // name of settings file in google appdatafolder
  settingsFilename: 'tacta-settings',
  // api key for dropbox
  DROPBOX_APP_KEY: 'z8sm9sp5t03ffej',
  backendUrl: 'https://tacta.zreptil.de/backend/index.php'
};
